import React from 'react';
export default function Footer() {
    return(   <footer className="footer py-5">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <h5 className="mb-3">Hotel Hilltop</h5>
                    <p>Experience luxury, history, and nature in perfect harmony. Your gateway to unforgettable memories in the heart of natural beauty.</p>
                    <div className="social-links">
                        <a href="#"><i className="fab fa-facebook"></i></a>
                        <a href="#"><i className="fab fa-instagram"></i></a>
                        <a href="#"><i className="fab fa-twitter"></i></a>
                        <a href="#"><i className="fab fa-youtube"></i></a>
                    </div>
                </div>
                <div className="col-lg-2 col-md-6 mb-4">
                    <h6 className="mb-3">Quick Links</h6>
                    <ul className="list-unstyled">
                        <li><a href="#home" className="text-light text-decoration-none">Home</a></li>
                        <li><a href="#about" className="text-light text-decoration-none">About</a></li>
                        <li><a href="#rooms" className="text-light text-decoration-none">Rooms</a></li>
                        <li><a href="#amenities" className="text-light text-decoration-none">Amenities</a></li>
                    </ul>
                </div>
                <div className="col-lg-2 col-md-6 mb-4">
                    <h6 className="mb-3">Services</h6>
                    <ul className="list-unstyled">
                        <li><a href="#" className="text-light text-decoration-none">Fort Tours</a></li>
                        <li><a href="#" className="text-light text-decoration-none">Nature Walks</a></li>
                        <li><a href="#" className="text-light text-decoration-none">Spa & Wellness</a></li>
                        <li><a href="#" className="text-light text-decoration-none">Adventure Sports</a></li>
                    </ul>
                </div>
                <div className="col-lg-4 mb-4">
                    <h6 className="mb-3">Newsletter</h6>
                    <p>Subscribe for special offers, seasonal packages, and updates about our nature experiences</p>
                    <div className="input-group">
                        <input type="email" className="form-control" placeholder="Your email address"/>
                        <button className="btn btn-primary" type="button">Subscribe</button>
                    </div>
                </div>
            </div>
            <hr className="my-4"/>
            <div className="row align-items-center">
                <div className="col-md-6">
                    <p className="mb-0">&copy; 2025 Hotel Hilltop. All rights reserved.</p>
                </div>
                <div className="col-md-6 text-md-end">
                    <p className="mb-0">Designed with <i className="fas fa-heart text-danger"></i> by Samyak Arwade.</p>
                </div>
            </div>
        </div>
    </footer>
    )
}